export enum PusherEventType {
  BuildStatus = 'build-status',
  DocEditingUpdate = 'doc-editing-update',
  ExtractionUpdated = 'extraction-updated',
  EsignPackageUpdated = 'esign-package-updated',
  WopiDocumentSave = 'wopi-document-save',
  SharepointDocumentSave = 'sharepoint-document-save',
  SharepointSessionEnded = 'sharepoint-session-ended',
  TicketUpdated = 'ticket-updated',
  WorkflowUpdated = 'workflow-updated',
}
